
import React from 'react';
import './footer.css';
const Footer = () => (
  <footer className="footer">
    <p>Developed by <a href="https://github.com/techmaxus" target="_blank">Lakshay Kapoor</a></p>
  
  </footer>
);
  
export default Footer;